const PrioritySelector = ({ index, arrPrioridade, setArrPrioridade }) => {
  const priorities = [
    { level: 0, color: '#D0D0D0', label: 'None' },
    { level: 1, color: '#FFCC00', label: 'Low' },
    { level: 2, color: '#FF9500', label: 'Medium' },
    { level: 3, color: '#F2645E', label: 'High' }
  ];

  return (
    <div style={{ 
      display: 'flex',
      width: '150px',
      height: '36px',
      borderRadius: '4px',
      overflow: 'hidden',
      border: '2px solid #ddd'
    }}>
      {priorities.map((priority) => (
        <div
          key={priority.level}
          onClick={() => {
            const newPriorities = [...arrPrioridade];
            newPriorities[index] = {
              ...newPriorities[index],
              id_entrada_fiscal: newPriorities[index].id_entrada_fiscal,
              prioridade: newPriorities[index].prioridade,
              nova_prioridade: priority.level
            };
            setArrPrioridade(newPriorities);
          }}
          style={{
            flex: 1,
            backgroundColor: priority.color,
            cursor: 'pointer',
            transition: 'all 0.2s',
            borderTopLeftRadius: priority.level === 0 ? '3px' : 'none',
            borderBottomLeftRadius: priority.level === 0 ? '3px' : 'none',
            borderTopRightRadius: priority.level === 3 ? '3px' : 'none',
            borderBottomRightRadius: priority.level === 3 ? '3px' : 'none',
            opacity: arrPrioridade[index]?.nova_prioridade === priority.level ? 1 : 0.7,
            boxShadow: arrPrioridade[index]?.nova_prioridade === priority.level ? 'inset 0 0 0 2px #00000090' : 'none',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '500'
          }}
          title={`Priority ${priority.level}: ${priority.label}`}
        >{priority.level}</div>
      ))}
    </div>
  );
}

export default PrioritySelector;
